import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  alpha,
} from '@mui/material'
import { CHANGELOG_ENTRIES, CHANGELOG_ABOUT } from '../../constants/changelog'

const ChangelogModal = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          bgcolor: theme =>
            theme.palette.mode === 'dark'
              ? alpha('#fff', 0.06)
              : theme.palette.background.paper,
        },
      }}
      aria-labelledby="changelog-title"
      aria-describedby="changelog-content"
    >
      <DialogTitle id="changelog-title" sx={{ pb: 0 }}>
        Changelog
      </DialogTitle>
      <DialogContent dividers id="changelog-content">
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 2, lineHeight: 1.6 }}
        >
          {CHANGELOG_ABOUT}
        </Typography>
        <Box component="ul" sx={{ m: 0, pl: 2.5, listStyle: 'disc' }}>
          {CHANGELOG_ENTRIES.map((entry, i) => (
            <Box
              component="li"
              key={i}
              sx={{
                mb: 1.5,
                '&::marker': { color: 'text.secondary' },
              }}
            >
              <Typography variant="body2" component="span" sx={{ fontWeight: 600 }}>
                {entry.date}
              </Typography>
              <Typography variant="body2" component="span" sx={{ ml: 0.5 }}>
                — {entry.description}
              </Typography>
            </Box>
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default ChangelogModal
